import { currencyFormatter } from '@/util-modules/currency';
import { AnyTypeToFix } from '@/model/AnyType';
export default {
    install(vue: AnyTypeToFix) {
        vue.prototype.$formatAsCurrency = currencyFormatter;
        vue.filter('formatAsCurrency', currencyFormatter);
    }
}
